export default "__VITE_ASSET__CjzNtXCZ__"